import React, { useEffect, useState } from 'react';
import { mdiAnchor, mdiCursorDefaultClick, mdiFormDropdown } from '@mdi/js';
import Icon from '@mdi/react';
import { useHistory, useLocation } from 'react-router-dom';
import { Menu } from 'antd';
import P from 'router/paths';
import { useWidgetDate } from 'store/redux/states/dates/dates.hooks';

const items = [
  {
    label: 'CRM',
    key: 'deal',
    url: P.SALES.CRM,
    icon: <Icon path={mdiFormDropdown} />,
  },
  {
    label: 'Postbacks',
    url: P.SALES.POSTBACKS,
    key: 'pb',
    icon: <Icon path={mdiAnchor} />,
  },
  {
    label: 'Events',
    url: P.SALES.EVENTS,
    key: 'event',
    icon: <Icon path={mdiCursorDefaultClick} />,
  },
];

const SalesMainMenu = ({ dateRangeComponent }) => {
  const { queryParams } = useWidgetDate('global');

  const [selected, setSelected] = useState();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const key = items.find((item) => item.url === location.pathname)?.key;
    setSelected(key);
  }, [location.pathname]);

  const onSelect = ({ key }) => {
    const selectedItem = items.find((item) => item.key === key);
    if (selectedItem) {
      history.push(selectedItem.url + queryParams);
      setSelected(key);
    }
  };

  return (
    <div className='flex px-4 pr-8 items-center justify-between flex-col sm:flex-row gap-2 pt-1'>
      <Menu
        className='w-full order-1 sm:order-0 !border-none'
        mode='horizontal'
        selectedKeys={[selected]}
        onSelect={onSelect}
        items={items}
      />
      <div className='sm:max-w-44 order-0 sm:order-1 w-full'>{dateRangeComponent}</div>
    </div>
  );
};

export default SalesMainMenu;
